import api from 'services/config';
import { IUpsertPersonRequest } from 'services/interfaces/request.interface';

export const upsertPerson = async (data: IUpsertPersonRequest) => {
  const response = await api.post('/person-v3/upsert-by-cpf', data);
  return response.data;
};
